import ServiceBusController from "servicestack/service-bus.controller";
import resolve from "ioc/resolve";

export default class ProductListDropdownMenuController extends ServiceBusController {
  constructor() {
    super();
    const $ctrl = this;
    $ctrl.$localStorage = resolve("$localStorage");
  }
}
